export const asDotSolidIcon = {
  data: `
    <svg class="h-2 w-2" fill="currentColor" viewBox="0 0 8 8">
      <circle cx="4" cy="4" r="3" />
    </svg>`,
  name: 'solid/dot'
};
